<template>
  <div class="requirement-container">
    <div class="fixed-wrapper">
      <div class="requirement-header">
        需求查询
      </div>
      <div class="search-row">
        <div class="requirement-material">
          <span>物料名称/编码</span>
          <el-input
            placeholder="请输入物料名称或物料编码"
            v-model="materialName"
            clearable
            size="mini"
          ></el-input>
        </div>
        <div class="search-brand">
          <span>品牌</span>
          <el-select
            v-model="brand"
            placeholder="请选择品牌"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-model">
          <span>机型</span>
          <el-select
            v-model="model"
            placeholder="请选择机型"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in modelList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-module">
          <span>模块</span>
          <el-select
            v-model="module"
            placeholder="请选择模块"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in moduleList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-quality">
          <span>品项</span>
          <el-select
            v-model="qualityCode"
            placeholder="请选择品项"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in qualityList"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          type="primary"
          size="mini"
          :loading="isLoading"
          @click="handleSearch"
          >查询</el-button
        >
      </div>
      <div class="status-row">
        <div
          v-for="(status, index) in statusArr"
          :key="index"
          :class="{ 'is-active': activeStatus === status }"
          @click="toggleStatus(status)"
        >
          {{ status }}
        </div>
      </div>
    </div>
    <div class="requirement-content" v-loading="isLoading">
      <keep-alive>
        <to-quote
          :requirementList="requirementList"
          :qualityList="qualityList"
          @getRequirementList="getRequirementList"
          v-if="activeStatus === '待报价'"
        />
        <quoted
          :requirementList="requirementList"
          @getRequirementList="getRequirementList"
          v-else-if="activeStatus === '已报价'"
        />
        <accepted
          :requirementList="requirementList"
          @getRequirementList="getRequirementList"
          v-else-if="activeStatus === '已受理'"
        />
      </keep-alive>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ToQuote from '@/components/requirement/ToQuote'
import Quoted from '@/components/requirement/Quoted'
import Accepted from '@/components/requirement/Accepted'
export default {
  components: {
    'to-quote': ToQuote,
    quoted: Quoted,
    accepted: Accepted
  },
  data() {
    return {
      materialName: '',
      brand: '',
      model: '',
      module: '',
      qualityCode: '',
      brandList: [],
      modelList: [],
      moduleList: [],
      qualityList: [],
      statusArr: ['待报价', '已报价', '已受理'],
      activeStatus: '待报价',
      requirementList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      isLoading: false
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/requirement')
    this.$store.commit('setAsideWidth', 150)
  },
  created() {
    this.getBrandList()
    this.getModelList()
    this.getModuleList()
    this.getQualityList()
    this.getRequirementList()
  },
  mounted() {},
  methods: {
    async getRequirementList() {
      this.isLoading = true
      const params = {
        materialName: this.materialName,
        brand: this.brand,
        model: this.model,
        module: this.module,
        quoteQuality: this.qualityCode,
        state: this.activeStatus,
        skipCount: (this.currentPage - 1) * this.pageSize,
        maxResultCount: this.pageSize
      }
      const res = await this.$http.get(
        '/api/services/inquiryApp/dIDetail/GetAll',
        params
      )
      this.requirementList = res.result.items
      this.total = res.result.totalCount
      this.isLoading = false
    },
    getBrandList() {
      this.$http
        .get('/api/services/inquiryApp/category/GetBrands')
        .then(res => {
          this.brandList = res.result.items.reverse()
        })
        .catch(err => {
          // this.$message.error(err.error.message)
          console.log(err)
        })
    },
    getModelList() {
      this.$http
        .get('/api/services/inquiryApp/category/GetMachines')
        .then(res => {
          this.modelList = res.result.items.reverse()
        })
        .catch(err => {
          // this.$message.error(err.error.message)
          console.log(err)
        })
    },
    getModuleList() {
      this.$http
        .get('/api/services/inquiryApp/category/GetModules')
        .then(res => {
          this.moduleList = res.result.items.reverse()
        })
        .catch(err => {
          // this.$message.error(err.error.message)
          console.log(err)
        })
    },
    getQualityList() {
      this.$http
        .get('/api/services/inquiryApp/productRecommend/GetQuality')
        .then(res => {
          this.qualityList = res.result
        })
        .catch(err => {
          // this.$message.error(err.error.message)
          console.log(err)
        })
    },
    handleSearch() {
      this.currentPage = 1
      this.getRequirementList()
    },
    toggleStatus(status) {
      this.activeStatus = status
      this.getRequirementList()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getRequirementList()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.getRequirementList()
    }
  }
}
</script>
<style lang="less" scoped>
.requirement-container {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.requirement-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  width: 100%;
}
.search-brand,
.search-model,
.search-module,
.search-quality,
.requirement-material {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 30px;
  span {
    margin-right: 15px;
    color: #2f343c;
  }
}
.requirement-material {
  width: 25%;
}
.search-row {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.status-row {
  height: 35px;
  display: flex;
  position: relative;
  margin-top: 15px;
  .is-active {
    border: 1px solid #027cff;
    color: #027cff;
    z-index: 5;
  }
  > div {
    height: 35px;
    padding: 0 10px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #b7bbc8;
    position: absolute;
    color: #2f343c;
    user-select: none;
    &:hover {
      border: 1px solid #027cff;
      color: #027cff;
      z-index: 5;
      cursor: pointer;
    }
    &:first-child {
      border-radius: 3px 0 0 3px;
      left: 0;
    }
    &:nth-child(2) {
      left: 63px;
    }
    &:last-child {
      left: 126px;
      border-radius: 0 3px 3px 0;
    }
  }
}
.requirement-content {
  height: calc(100% - 210px);
  margin-top: 15px;
}
.pagination-wrapper {
  padding-top: 20px;
  border-top: 1px solid #ededed;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
